import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { denyVolunteersBulkActionType, } from '../schemas/denyVolunteersSchema';
import { canDenyVolunteers, filterShiftParticipantsToDeny } from '../utils';
import { denyVolunteers } from '../utils/denyVolunteers';
export const denyVolunteersBulkAction = defineBulkAction({
    type: denyVolunteersBulkActionType,
    onAuthRunSync: () => true,
    onAuthBulkAction: (userContext, { data }) => {
        const { status, shiftId, shiftParticipations, missionTypeId } = data.params;
        canDenyVolunteers(userContext, { missionTypeId, status });
        const participantIds = shiftParticipations.map(({ participantId }) => participantId);
        return { secureFilter: filterShiftParticipantsToDeny({ shiftId, status, participantIds }) };
    },
    onProcessBulkAction: (appContext, { data, updateProcessedCount, updateTotalCount }) => {
        denyVolunteers(appContext, {
            data: data.params,
            updateProcessedCount,
            updateTotalCount,
            filter: data.secureParams.secureFilter,
        });
    },
});
